import { useState } from "react";
import { Box, Tab, Tabs, Accordion, AccordionDetails } from "@mui/material";
import { Gamer } from "./Gamer";
import { Developer } from "./Developer";
import { Platform } from "./Platform";
import { Glossary } from "./Glossary";
import { Plans } from "./Plans";
function InternalPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
export function Works() {
  const [get_value, set_value] = useState(1);
  const handleTab = (i) => {
    set_value(i);
    window.scrollTo(0, 0);
  };
  const handleSet = (p) => {
    switch (p) {
      case "__platform__":
        handleTab(1);
        break;
      case "__developer__":
        handleTab(2);
        break;
      case "__consumer__":
        handleTab(3);
        break;
      case "__glossary__":
        handleTab(5);
        break;
      case "__access__":
        handleTab(6);
        break;
      default:
        break;
    }
  };
  return (
    <>
      <Box pt={10} pl={5}>
        <Accordion
          className="pk__accordion"
          expanded={true}
          onChange={() => {}}
        >
          <AccordionDetails>
            <Tabs
              orientation="vertical"
              value={get_value}
              onChange={(e, o) => handleTab(o)}
            >
              <Tab
                disabled
                className="pk__section"
                label="Legal Agreements"
                index={0}
              />
              <Tab
                className="pk__tab"
                label="polycaik platform Agreement"
                index={1}
              />
              <Tab
                className="pk__tab"
                label="schedule a: polycaik developer agreement"
                index={2}
              />
              <Tab
                className="pk__tab"
                label="schedule b: polycaik gamer agreement"
                index={3}
              />
              <Tab
                disabled
                className="pk__section"
                label="Guidelines"
                index={4}
              />
              <Tab
                className="pk__tab"
                label="Uniform Definitions"
                index={5}
              />
              <Tab
                className="pk__tab"
                label="Access Plans & User Roles"
                index={6}
              />
            </Tabs>
          </AccordionDetails>
        </Accordion>
      </Box>
      <InternalPanel value={get_value} index={1}>
        <Platform panel={handleSet} />
      </InternalPanel>
      <InternalPanel value={get_value} index={2}>
        <Developer
          panel={(p) => {
            switch (p) {
              case "__platform__":
                handleTab(1);
                break;
              default:
                handleTab(5);
                break;
            }
          }}
        />
      </InternalPanel>
      <InternalPanel value={get_value} index={3}>
        <Gamer
          panel={(p) => {
            switch (p) {
              case "__platform__":
                handleTab(1);
                break;
              default:
                handleTab(5);
                break;
            }
          }}
        />
      </InternalPanel>
      <InternalPanel value={get_value} index={5}>
        <Glossary
          panel={(p) => {
            switch (p) {
              case "__developer__":
                handleTab(2);
                break;
              case "__consumer__":
                handleTab(3);
                break;
              default:
                break;
            }
          }}
        />
      </InternalPanel>
      <InternalPanel value={get_value} index={6}>
        <Plans panel={(p) => {}} />
      </InternalPanel>
    </>
  );
}
